import { VIEWER_SET_SHOW_CT_WINDOWING } from '../actions';

export default function setShowCTWindowing(show) {
  return {
    type: VIEWER_SET_SHOW_CT_WINDOWING,
    show,
  };
}
